import { SWIM_SURFACE_ANCHOR_HEIGHT, WaterLocomotion, sampleWorldWaterAt, type WorldWaterSample } from "@endclock/shared";

/** Reference-surface decisions only; GPU wave phases never reach this class. */
export class WaterCamera {
  private swimmingBlend = 0;
  private submerged = false;
  underwaterAmount = 0;

  targetY(rootY: number, locomotion: WaterLocomotion, delta: number): number {
    this.swimmingBlend += ((locomotion === WaterLocomotion.Swimming ? 1 : 0) - this.swimmingBlend)
      * (1 - Math.exp(-8 * Math.max(0, delta)));
    // Camera adds its normal 1.2m target height. Shift the swim target toward
    // the rig's head/upper shoulders (0.25m above the shared surface anchor).
    return rootY + this.swimmingBlend * (SWIM_SURFACE_ANCHOR_HEIGHT + 0.25 - 1.2);
  }

  update(position: readonly number[], delta: number, sample: (x: number, z: number) => WorldWaterSample = sampleWorldWaterAt): number {
    const water = sample(position[0]!, position[2]!);
    const depth = water.surfaceY - position[1]!;
    if (!water.inside || depth < -0.12) this.submerged = false;
    else if (depth > 0.08) this.submerged = true;
    this.underwaterAmount += ((this.submerged ? 1 : 0) - this.underwaterAmount)
      * (1 - Math.exp(-5 * Math.max(0, delta)));
    if (this.underwaterAmount < 0.001) this.underwaterAmount = 0;
    return this.underwaterAmount;
  }
}
